module.exports = __webpack_public_path__ + "static/husky-82614818a6edbb1b61ceeb7121402cdb.png";